import React from 'react';
import { LayoutContentWrapper } from './LayoutWrapper.style';

export function LayoutWrapper(props) {
    const { className, children } = props;
    return (
        <LayoutContentWrapper
            className={
                className != null
                    ? `${className} isoLayoutContentWrapper`
                    : 'isoLayoutContentWrapper'
            }
            {...props}
        >
            {children}
        </LayoutContentWrapper>
    );
}
